// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._11c82smr{font:var(--ds-font-body,normal 400 14px/20px ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}\n._18zrv77o{padding-inline:var(--ds-space-025,2px)}\n._1e0c1txw{display:flex}\n._1nmz9jpi{word-break:break-all}\n._1o9zidpf{flex-shrink:0}\n._1ul9idpf{min-width:0}\n._o5721q9c{white-space:nowrap}\n._p12f1osq{max-width:100%}", ""]);
// Exports
module.exports = exports;
